import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
export var getCurrentUrl = function() {
    return [
        getLocationOrThrow().pathname,
        getLocationOrThrow().search
    ].join("");
};
export var getEventStartTime = function(event) {
    var _performance, _entryList_;
    var entryList = (_performance = performance) === null || _performance === void 0 ? void 0 : _performance.getEntriesByName(event);
    return entryList === null || entryList === void 0 ? void 0 : (_entryList_ = entryList[0]) === null || _entryList_ === void 0 ? void 0 : _entryList_.startTime;
};
export var waitForFrameDelayBelowThreshold = function(frameTimeThresholdMs, onThresholdReached) {
    var previousTickTime = performance.now();
    var onTick = function() {
        if (performance.now() - previousTickTime < frameTimeThresholdMs) {
            onThresholdReached();
        } else {
            previousTickTime = performance.now();
            scheduleTick();
        }
    };
    var scheduleTick = function() {
        var _getWindowOrThrow = getWindowOrThrow(), document = _getWindowOrThrow.document, requestAnimationFrame = _getWindowOrThrow.requestAnimationFrame;
        if (document.visibilityState === "visible") {
            requestAnimationFrame(onTick);
        } else {
            setTimeoutIfPossible(onTick, 1);
        }
    };
    scheduleTick();
};
